import { createSlice } from "@reduxjs/toolkit";

import { forgetUserThunk, sendNewResetPasswordThunk } from "./thunks";

const initialState = {
  forgetSuccessMsg: "",
  forgetError: "",
  forgotLoading: false,

  resetPasswordError: "",
  resetPasswordSuccess: "",
  resetLoading: false,
};

export const forgetPwdSlice = createSlice({
  name: "forgetPwdSlice",
  initialState,
  reducers: {
    forgetPwdClearStore: state => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: builder => {
    builder.addCase(forgetUserThunk.pending, state => {
      state.forgetSuccessMsg = "";
      state.forgetError = "";
      state.forgotLoading = true;
    });
    builder.addCase(forgetUserThunk.fulfilled, state => {
      state.forgotLoading = false;
      state.forgetSuccessMsg =
        "Reset link are sended to your mailbox, check there first";
    });
    builder.addCase(forgetUserThunk.rejected, (state, { payload }) => {
      state.forgotLoading = false;
      state.forgetError = payload?.message || "";
    });
    builder.addCase(sendNewResetPasswordThunk.pending, state => {
      state.resetLoading = true;
      state.resetPasswordError = "";
    });
    builder.addCase(sendNewResetPasswordThunk.fulfilled, state => {
      state.resetLoading = false;
      state.resetPasswordSuccess = "Successfully changed password";
    });
    builder.addCase(
      sendNewResetPasswordThunk.rejected,
      (state, { payload }) => {
        state.resetLoading = false;
        state.resetPasswordError = "Token is invalid";
      }
    );
  },
});

export const { forgetPwdClearStore } = forgetPwdSlice.actions;

export default forgetPwdSlice.reducer;
